<template>
    <div class="header">
        <div class="navbar">
            <div class="navbar-content">
                <div class="logo">
                    <router-link to="/">
                        <img src="../assets/img/ata-logo.png" >
                    </router-link>
                </div>
                <div id="nav" class="nav">
                    <div class="mobile-nav">
                        <img class="nav-close" @click="handleMenu" src="../assets/img/mobile/close-icon.png">
                        <div v-if="userToken">
                            <img class="nav-logo" src="../assets/img/student-profile-image.png" @click="handleRoute()">
                            <span class="nav-name">
                                Hi,
                                <span>
                                    {{username}}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="navbtn">
                        <router-link to="/featuredCourse">
                            Courses
                        </router-link>
                    </div>
                    <div class="navbtn">
                        <router-link to="/privateClass">
                            Private Class
                        </router-link>
                    </div>
                    <div class="navbtn">
                        <router-link to="/aboutUs">
                            About Us
                        </router-link>
                    </div>
                    <div class="navbtn">
                        <router-link to="/contactUs">
                            Contact Us
                        </router-link>
                    </div>
                    <div class="mobile-nav navbtn" @click="logout()"  v-if="userToken">
                        Logout
                    </div>
                    <div class="navbtn" v-if="!userToken">
                        <router-link to="/login">
                            Login
                        </router-link>
                    </div>
                    <div class="signup" v-if="!userToken">
                        Sign Up
                    </div>
                    <div class="header-user-info" @mouseover="isShowUserMenu = true" @mouseleave="isShowUserMenu = false" v-else>
                        <div class="header-user-info-icon">
                            <img src="../assets/img/student-profile-image.png">
                        </div>
                        <div class="header-user-info-name">
                            Hi,
                            <span>
                                {{username}}
                            </span>
                            <i class="fa fa-angle-down" aria-hidden="true">
                            </i>
                        </div>
                        <div class="header-user-nav-list" @mouseover="isShowUserMenu = true" @mouseleave="isShowUserMenu = false" v-show="isShowUserMenu">
                            <center>
                                <router-link to="/user/myCourse">
                                    My Courses
                                </router-link>
                                <div class="horizontal-bar">
                                </div>
                                <router-link to="/user/billing">
                                    Billings
                                </router-link>
                                <div class="horizontal-bar">
                                </div>
                                <router-link to="#" @click="logout()">
                                    Logout
                                </router-link>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-navbar">
            <div class="logo">
                <router-link to="/">
                    <img src="../assets/img/mobile/ata-logo.png" >
                </router-link>
                <img @click="handleMenu" class="menu-icon" src="../assets/img/mobile/menu-icon.png" >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        data() {
            return {
                showMenu: false,
                isShowUserMenu: false,

                /* get user info */
                username: ""
            }
        },
        created() {
            window.addEventListener("resize", this.myEventHandler);
        },
        mounted() {
            this.init();
        },
        methods: {
            /* get user info */
            init() {
                if (this.userToken) {
                    this.$api.request('User/info').then((result) => {
                        if (result.status == true) {
                            let results = result.data;
                            this.username = results.name;
                        } else {
                            this.$message.error(result.msg);
                        }
                    }).catch(error => {
                        this.$message.error(error.msg);
                    });
                }
            },
            handleRoute() {
                this.showMenu = false;
                document.getElementById('nav').style.display = 'none';
                this.$router.push({path: '/user'});
            },
            handleMenu(){
                if(this.showMenu == false){
                    this.showMenu = true;
                    document.getElementById('nav').style.display = 'block';
                } else{
                    this.showMenu = false;
                    document.getElementById('nav').style.display = 'none';
                }
            },
            myEventHandler() {
                if (window.innerWidth >= 701) {
                    document.getElementById('nav').style.display = 'flex';
                } else {
                    this.showMenu = false;
                    document.getElementById('nav').style.display = 'none';
                }
            },
            logout() {
                this.$api.request('User/logout').then((result) => {
                    if (result.status == true) {
                        localStorage.removeItem('token');
                        this.$message.warning('Logout successfully');

                        setTimeout(function() {
                            window.location = '/index';
                        }, 1500);
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            },
        },
        watch: {
        },
    }
</script>
<style lang="scss">
    @import "../styles/pc/header.scss";
    @import "../styles/mobile/header.scss";
</style>
